import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { PosCreateComponent } from '../../points-of-sale/pos-create/pos-create.component';
import { GuardService } from '../../service/guard.service';

@Injectable({
  providedIn: 'root'
})
export class CanDeactivatePosCreateGuard {
  constructor(private readonly guardService: GuardService) {}
  canDeactivate(component: PosCreateComponent): Observable<boolean> | boolean {
    return this.guardService.canDeactivate(component);
  }
}
